
























































import {
  BusinessScene,
  GetSceneParamsType,
  JumpButtonType,
  MobileBusinessComponent,
  MobileBusinessComponentInfoMap,
  PlatformType,
} from '../business/scene/type';
import { Vue, Component } from 'vue-property-decorator';
import { biHottag, util } from '@tencent/ppd-base-libs';
import { CustomException } from '@/utils/error';
import {
  queryGetScheme,
  SchemeResp,
  IsInsideWx,
  HasReachLimit,
  BusiType,
  SceneType,
  GET_SCHEME_ERR_CODE_ARR,
  BusiSceneEnum,
  WxOpenapi,
  queryWxOpencgi,
} from '@/api';
import { objToQueryType } from '@/utils/url';
import { getLanguage, getSystemLanguage } from '@/i18n';
import BusinessLaunchWeApp from '@/components/BusinessLaunchWeApp.vue';
import PcBusinessCard from '@/components/PcBusinessCard.vue';
import BusinessCard from '@/components/BusinessCard.vue';
import Copy from '@/components/Copy.vue';
import H52WeApp from '@/components/H52WeApp.vue';
import { FitButton } from '@/fit-ui';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import { getSceneConfig } from '@/business/scene/index';
import { getEnv } from '@/business/client';
import { urlParamsFilter } from '@/business/url';
import { initParameterA } from '@/business/encryptedInfo';
import { jsApiInit } from '@/business/wx';
import { getParameterByName } from '@/utils';
import { COPYRIGHT_TEXT } from '@/business/scene/constants';
import { report } from '@tencent/ppd-report-sdk-web';

@Component({
  components: {
    BusinessLaunchWeApp,
    BusinessCard,
    PcBusinessCard,
    H52WeApp,
    FitButton,
    Copy,
  },
})
export default class Home extends Vue {
  // 小程序配置
  public miniappConfig = {
    username: 'gh_a3001a506552',
    path: '',
  };
  public copyText = COPYRIGHT_TEXT;

  /**
   * 【核心】场景信息
   */
  public sceneInfo: GetSceneParamsType = {
    platform: PlatformType.MOBILE_OUTSIDE_WX,
    // 默认为小鹅快收 - 收款人视角场景
    businessScene: BusinessScene.QUICK_RECEIPT_RECEIVER,
    hasReachLimit: HasReachLimit.IN_LIMIT,
    copyLink: '',
  };

  /**
   * 【核心】对客展示的场景样式信息
   */
  public sceneStyleInfo: MobileBusinessComponentInfoMap = {
    [MobileBusinessComponent.LOGO]: '',
    [MobileBusinessComponent.LOGO_TITLE]: '',
    [MobileBusinessComponent.MAIN_TEXT]: '',
    [MobileBusinessComponent.MINI_APP_QRCODE]: '',
    [MobileBusinessComponent.JUMP_BUTTON]: null,
    [MobileBusinessComponent.SUB_TEXT]: '',
    [MobileBusinessComponent.COPY_LINK]: '',
  };

  // 业务类型 - 默认为小鹅快收
  // 当前只用于数据上报
  public busiType: BusiType = BusiType.WE_REMIT_GPC;

  // 【核心】 url里的加密串
  public encryptedInfo = '';

  // 是否为可重试的错误
  public canRetry = false;

  /**
   * 页面可视标志位，用于防止页面突变
   */
  public visibleKey = false;

  /**
   * 存在小程序码时CSS类
   * 样式相关的css类
   */
  public get hasQrCodeClass() {
    return this.sceneStyleInfo.miniAppQrCode ? 'hasQrCode' : '';
  }

  // 是否是桌面端
  public get isDesktop() {
    return this.sceneInfo.platform === PlatformType.PC;
  }

  /**
   * 是否展示端内的开放标签
   * 1、非微信端外
   * 2、且配置的按钮跳转类型是开放标签
   * 3、且配置了跳转路径
   */
  public get showOpenTag() {
    return (
      this.sceneStyleInfo.jumpButton?.buttonType === JumpButtonType.OPEN
      && this.sceneStyleInfo.jumpButton?.path
    );
  }

  /**
   * 是否展示端外的urlScheme跳转按钮
   * 条件：
   * 1、在微信端外
   * 2、且（用户可重试）或（按钮类型是scheme按钮，且配置了urlScheme）
   */
  public get showUrlSchemeButton() {
    return this.canRetry
      || (
        this.sceneStyleInfo.jumpButton?.buttonType === JumpButtonType.URL_SCHEME_BUTTON
        && this.sceneStyleInfo.jumpButton?.urlScheme
      );
  }

  // bi拓展字段
  public get biHottagValue() {
    return {
      busi: this.busiType, // 业务类型
      limit: `${this.sceneInfo.hasReachLimit}`, // 是否超限
      linkid: this.encryptedInfo, // 链接id
      insideWx:
        this.sceneInfo.platform === PlatformType.MOBILE_INSIDE_WX
          ? IsInsideWx.YES
          : IsInsideWx.NO, // 端内/端外
      language: getLanguage(), // 格式化后的语言
      systemLanguage: getSystemLanguage(), // 系统语言
      businessScene: `${this.sceneInfo.businessScene}`, // 业务场景
    };
  }

  /**
   * 尝试通过URL scheme跳转小程序，如果没有配置urlScheme，则请求后台接口获取urlScheme
   * 端外打开中转页，通过URL scheme的方式跳转小程序
   */
  public async jumpByUrlScheme() {
    biHottag('common.miniapp.link.confirm_click', {
      ...this.biHottagValue,
    });
    if (!this.sceneInfo.urlScheme) {
      new CustomException(
        null,
        'clickButtonWithoutScheme',
        '点击按钮时无url scheme',
      );

      // 如果本地没有urlScheme，说明此前调用getScheme接口失败
      // 再次初始化urlScheme
      showLoading();
      const [err] = await util.to(this.initOutsideWxUrlScheme());
      hideLoading();
      if (err) {
        return;
      }
    }
    if (this.sceneInfo.urlScheme) {
      location.href = this.sceneInfo.urlScheme;
    }
  }

  /* 封装接口调用 - 开始 */

  /**
   * 调用后端微信开发能力CGI
   */
  public async queryWxOpenapi(wxOpenapi: WxOpenapi) {
    return queryWxOpencgi(
      this.encryptedInfo,
      wxOpenapi,
      'package-quick-receipt/pages/remitter-share/index',
    );
  }

  /**
   * 调用后端getScheme接口
   */
  public async queryScheme() {
    return queryGetScheme(
      this.encryptedInfo,
      this.sceneInfo.platform === PlatformType.MOBILE_INSIDE_WX
        ? IsInsideWx.YES
        : IsInsideWx.NO,
    );
  }

  /* 封装接口调用 - 结束 */

  /**
   * 调用后端getScheme接口，并对返回值做统一处理
   */
  public async getScheme() {
    // 若url中没有参数a，则抛错异常并不掉后端接口
    if (!this.encryptedInfo) {
      // 命中链接错误场景
      this.sceneInfo.businessScene = BusinessScene.ERROR_LINK;
      // 抛出异常
      throw new CustomException(
        null,
        'getSchemeWithoutEncryptedInfo',
        '调getScheme前无参数a',
      );
    }

    showLoading();
    // 调用getScheme接口
    const [err, response] = await util.to(this.queryScheme());
    hideLoading();

    if (err) {
      // 如果命中getScheme不可重试错误码
      if (GET_SCHEME_ERR_CODE_ARR.includes(+err.retcode)) {
        // 命中链接错误场景
        this.canRetry = false;
        this.sceneInfo.businessScene = BusinessScene.ERROR_LINK;
      } else {
        if (this.sceneInfo.platform === PlatformType.MOBILE_OUTSIDE_WX) {
          // 可重试的错误
          this.canRetry = true;
        } else {
          this.sceneInfo.businessScene = BusinessScene.ERROR_LINK;
        }
      }
      // 如果命中错误，则抛出异常
      throw new CustomException(err, 'getSchemeFailed', '获取Scheme码失败');
    }

    // 根据接口返回值初始化场景
    this.initBusinessScene(response);

    return response;
  }

  /**
   * 调用后端微信开发能力cgi获取小程序码
   */
  public async getQrcode() {
    const [err, res] = await util.to(this.queryWxOpenapi(WxOpenapi.qrcode));
    console.log('小程序码', err, res);
    if (err || !res.wx_openapi_res) {
      new CustomException(
        err,
        'remitterPc_getQrcode_err',
        '汇款人PC端获取小程序码失败',
      );
      // 如果接口调用失败，则展示兜底的小程序码
      this.$set(
        this.sceneStyleInfo,
        'miniAppQrCode',
        '//weremit-static.tenpay.com/upload-static/tgb/QmNJng8nXvIrBjRRYks89h-image73.png',
      );
    } else {
      const buffer = `data:image/png;base64,${(res as any).wx_openapi_res}`;
      this.$set(this.sceneStyleInfo, 'miniAppQrCode', buffer);
    }
  }

  /**
   * 初始化端内小程序配置
   */
  public async initInsideWxConfig() {
    // 端内打开同样会调用getScheme接口，来获取小程序路径
    const [err, res] = await util.to(this.getScheme());

    if (err) {
      throw err;
    }

    // 将收款人链接填入复制链接区
    this.initCopyLink(res);

    // 根据返回值获取字符串格式的参数
    const paramStr = objToQueryType(urlParamsFilter(res), false);

    // 保存开放标签跳转路径
    this.sceneInfo.openPath = res ? `${res.path}?${paramStr}` : '';

    // 上报小程序配置
    report.reportInfo({
      key: 'weAppConfig_getScheme',
      msg: JSON.stringify(res),
    });

    report.reportInfo({
      key: 'miniappConfig',
      msg: JSON.stringify(this.miniappConfig),
    });
  }

  /**
   * 端外场景初始化urlScheme
   */
  public async initOutsideWxUrlScheme() {
    const [err, res] = await util.to(this.getScheme());
    if (!err) {
      this.busiType = res?.busi_type; // 业务类型
      // 将收款人链接填入复制链接区
      this.initCopyLink(res);
      // 保存urlScheme
      this.sceneInfo.urlScheme = res?.scheme;
      // 保存是否超限
      this.sceneInfo.hasReachLimit = res?.has_reach_limit;

      // 如果已经超限且在端外，则自定义告警
      if (
        this.sceneInfo.hasReachLimit !== HasReachLimit.IN_LIMIT
        && this.sceneInfo.platform === PlatformType.MOBILE_OUTSIDE_WX
      ) {
        new CustomException(null, 'web2miniprogramOutLimit', '中转页超限');
      }

      this.initSceneStyle();
    } else {
      this.initSceneStyle();
      throw err;
    }
  }

  /**
   * PC端场景初始化
   */
  public async initPcInfo() {
    const response = await this.getScheme();
    this.busiType = response?.busi_type; // 业务类型

    // 将收款人链接填入复制链接区
    this.initCopyLink(response);

    // 初始化场景信息
    this.initSceneStyle();
  }

  public async created() {
    // 初始化环境
    report.reportInfo({
      key: 'web2miniprogram_lifecycle',
      msg: 'created',
    });
    this.sceneInfo.platform = getEnv();
  }

  public async mounted() {
    // 从url中初始化参数
    this.encryptedInfo = initParameterA(getParameterByName('a') || this.$route.params.encryptedInfo);
    if (!this.encryptedInfo) {
      // 链接异常场景
      this.sceneInfo.businessScene = BusinessScene.ERROR_LINK;
    }

    // 各平台第一次初始展示
    this.initSceneStyle();

    // 根据平台进行差异化初始化展示
    this.initPlatform();
  }

  /**
   * 根据平台进行差异化初始化
   */
  public initPlatform() {
    // 收拢第一次初始化逻辑
    switch (this.sceneInfo.platform) {
      case PlatformType.PC:
        this.initPc();
        break;
      case PlatformType.MOBILE_INSIDE_WX:
        this.initInsideWx();
        break;
      case PlatformType.MOBILE_OUTSIDE_WX:
        this.initOutsideWx();
        break;
    }
  }

  /**
   * PC端初始化
   */
  public async initPc() {
    // 事件上报
    report.reportInfo({
      key: 'web2miniprogram_platform',
      msg: 'pc',
    });
    biHottag('common.miniapp.link_pc.brow', {
      ...this.biHottagValue,
    });


    showLoading();
    const [err] = await util.to(this.initPcInfo()); // 初始化Pc端信息
    hideLoading();
    this.showPage();

    if (err) {
      new CustomException(err, 'mountedLaunchAppFail', 'PC端调用接口失败');
      return;
    }
    // 如果命中汇款人视角，还要请求接口展示小程序码
    if (this.sceneInfo.businessScene === BusinessScene.QUICK_RECEIPT_REMITTER) {
      this.getQrcode();
    }
  }

  /**
   * 端内初始化
   */
  public async initInsideWx() {
    // 事件上报
    report.reportInfo({
      key: 'web2miniprogram_platform',
      msg: 'weixin',
    });

    showLoading();
    // 只有微信端内跳转小程序时，需要初始化jssdk
    const [jsapiErr] = await util.to(jsApiInit());
    hideLoading();

    if (jsapiErr) {
      new CustomException(jsapiErr, 'mountedJsApiInitFail', '端内初始化jsApi失败');
      // jsapi初始化失败时命中链接异常场景
      this.sceneInfo.businessScene = BusinessScene.ERROR_LINK;
      this.initSceneStyle();
      this.showPage();
      return;
    }

    // 微信端内使用开放标签跳转小程序，此处初始化小程序相关配置
    const [mpErr] = await util.to(this.initInsideWxConfig());

    if (mpErr) {
      // 如果初始化小程序配置出错了
      new CustomException(mpErr, 'mountedLaunchAppFail', '端内打开小程序失败');
      this.sceneInfo.businessScene = BusinessScene.ERROR_LINK;
    }

    // 初始化样式
    this.initSceneStyle();

    this.showPage();

    // 上报事件 - 中转页【确认打开】按钮曝光
    if (this.sceneStyleInfo.jumpButton) {
      biHottag('common.miniapp.link.confirm_brow', {
        ...this.biHottagValue,
      });
    }
  }

  /**
   * 端外初始化
   */
  public async initOutsideWx() {
    // 事件上报
    report.reportInfo({
      key: 'web2miniprogram_platform',
      msg: 'other',
    });

    showLoading();
    const [err] = await util.to(this.initOutsideWxUrlScheme()); // 初始化跳转url scheme
    hideLoading();

    this.showPage();

    // 上报事件 - 中转页-曝光
    biHottag('common.miniapp.link.brow', {
      ...this.biHottagValue,
    });

    // 上报事件 - 中转页【确认打开】按钮曝光
    biHottag('common.miniapp.link.confirm_brow', {
      ...this.biHottagValue,
    });

    if (err) {
      new CustomException(err, 'mountedLaunchAppFail', '短信打开小程序失败');
      return;
    }

    // 如果初始化阶段拿到了url scheme，则将尝试自动跳转，此时上报自动跳转事件
    // 上报事件 - 中转页弹窗曝光
    biHottag('common.miniapp.link.window_brow', {
      ...this.biHottagValue,
    });

    this.jumpByUrlScheme(); // 初始化url scheme后，自动跳转
  }

  /**
   * 根据getScheme接口返回值初始化场景
   */
  public async initBusinessScene(schemeResp: SchemeResp) {
    console.log('业务场景参数', schemeResp);
    // 汇款人场景
    if (schemeResp?.busi_info?.busiScene === BusiSceneEnum.REMITTER) {
      this.sceneInfo.businessScene = BusinessScene.QUICK_RECEIPT_REMITTER;
    } else if (schemeResp.scene_type === SceneType.SMS) {
      // 小鹅快收 - 收款人视角场景
      this.sceneInfo.businessScene = BusinessScene.QUICK_RECEIPT_RECEIVER;
    } else if (schemeResp.scene_type === SceneType.MARKETING) {
      // 通用营销场景
      this.sceneInfo.businessScene = BusinessScene.COMMON_MARKETINGS;
    }
    console.log('业务场景', this.sceneInfo.businessScene);
  }

  /**
   * 根据当前场景信息初始化展示
   * 在以下场景里初始化页面展示：
   * 1、首次进入页面时
   * 2、调用getScheme后
   */
  public initSceneStyle() {
    const sceneStyleInfo = getSceneConfig(this.sceneInfo);
    this.sceneStyleInfo = sceneStyleInfo;
    console.log('场景信息', this.sceneInfo, this.sceneStyleInfo);
  }

  /**
   * 展示页面
   * 在获取到页面信息后，将页面可视标志位置为true，同时进行上报
   */
  public showPage() {
    this.visibleKey = true;
  }

  /**
   * 根据接口返回值初始化复制链接组件
   */
  public initCopyLink(response: SchemeResp) {
    // 将收款人链接填入复制链接区
    const receiverUrl = response?.busi_info?.receiverUrl;
    const decodeUrl = receiverUrl ? decodeURIComponent(receiverUrl) : '';
    this.sceneInfo.copyLink = decodeUrl;
    if (decodeUrl) {
      biHottag('common.miniapp.link.copy_brow', {
        ...this.biHottagValue,
      });
    }
  }

  public onClickCopyBtn() {
    biHottag('common.miniapp.link.copy_click', {
      ...this.biHottagValue,
    });
  }

  public onCopySuccess() {
    // 事件上报
    report.reportInfo({
      key: 'web2miniprogram_copySuccess',
      msg: 'web2miniprogram_copySuccess',
    });
  }

  public onCopyFail() {
    new CustomException(null, 'web2miniprogram_copyFail', '中转页复制失败');
  }
}
